import { ConversationBadge } from '@vacationtracker/shared/types/conversation'

export interface IVeeConversationInfo {
  id: string
  topic?: string
  timestamp?: string
  updatedAt?: string
  badge?: ConversationBadge
}

export interface IVeeMessageItem {
  id: string
  role: 'user' | 'assistant'
  content?: string
  timestamp: string
  type: string
  metadata?: string
}

export interface IVeePendingConfirmation {
  toolName: string
  toolInput: Record<string, unknown>
  presentsNativeForm?: boolean
}

export interface IVeeMessageMetadata {
  pendingConfirmations?: IVeePendingConfirmation[]
  confirmationToken?: string
  toolCalls?: Array<{
    toolName: string
    toolInput?: Record<string, unknown>
    toolResult?: {
      success?: boolean
      data?: Record<string, unknown>
    }
  }>
  previews?: Array<{
    toolName: string
    data?: Record<string, unknown>
  }>
  options?: string[]
  error?: boolean
}

export interface IVeeSendResponse {
  conversationId?: string
  limitReached?: boolean
  limit?: number
  remaining?: number
  accessDenied?: boolean
}

export function parseVeeMetadata(metadata?: string): IVeeMessageMetadata | undefined {
  if (!metadata) {
    return undefined
  }
  try {
    return JSON.parse(metadata) as IVeeMessageMetadata
  } catch {
    return undefined
  }
}
